import { TestPlanScreeningType } from '@/app/components/testing-plan/components/your-testing-plan/types';
import IconCatch from '@/components/icons/icon-catch/icon-catch';
import { snakeCaseToTitleCase } from '@/utils/common';
import { Badge, Flex } from '@cmpsr/components';

export default function Header({ iconId, icon }: TestPlanScreeningType) {
  const defaultIcon = 'biomarkers';

  const diseaseType = icon === 'biomarkers' ? 'All Cancers' : icon.charAt(0).toUpperCase() + icon.slice(1);

  return (
    <Flex as="header" alignItems="center" justifyContent="space-between" mb={4}>
      <IconCatch
        size="xl"
        icon={iconId ?? defaultIcon}
        position="relative"
        top="-1px"
        left="-1px"
        backgroundColor="tan"
        borderRight="1px solid"
        border="1px solid"
        borderColor="cream"
        borderRadius="radii-3"
        borderTopRightRadius={0}
        borderBottomLeftRadius={0}
        alt={icon}
      />
      <Badge
        variant="solid"
        backgroundColor="tan"
        color="darkBlue"
        px={3}
        py={1}
        mr={{ base: 5, lg: 6 }}
        borderRadius="radii-1"
        textTransform={'none'}
      >
        {snakeCaseToTitleCase(diseaseType)}
      </Badge>
    </Flex>
  );
}
